import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { handleFetchError } from 'src/Libs/api/utils'

export const deleteSystem = async (
  installationId: number | string,
  deviceLinkId: number | string | undefined,
  payload: { reason: string },
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<null>> => {
  if (!deviceLinkId) {
    return new ApiResult<null>(null, true, 'No device link found')
  }
  try {
    const response = await authFetch<void>({
      path: `installations/${installationId}/decommission/${deviceLinkId}`,
      method: 'PUT',
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      payload,
    })

    if (response.status === StatusCodes.NO_CONTENT) {
      return new ApiResult<null>(null, false)
    }

    return new ApiResult<null>(null, true)
  } catch (error) {
    return handleFetchError(error)
  }
}
